import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as styles from './cards-carousel.css';

const CardsCarousel = ({ children, carouselSettingsOverride = {} }) => {
  const carouselRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.disconnect();
          }
        },
        {
          threshold: 0.1,
        }
      );

      if (carouselRef.current) {
        observer.observe(carouselRef.current);
      }

      return () => {
        observer.disconnect();
      };
    } else {
      // Fallback for older browsers
      setInView(true);
    }
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: inView,
    autoplaySpeed: 5000,
    arrows: false,
    ...carouselSettingsOverride,
  };

  return (
    <div ref={carouselRef}>
      <Slider
        {...settings}
        className={`cardsCarousel ${
          !settings.infinite &&
          Array.isArray(children) &&
          children.length <= settings.slidesToScroll
            ? 'centeredCarousel'
            : ''
        }`}
      >
        {children}
      </Slider>
    </div>
  );
};

export default CardsCarousel;
